<template>
	<div class="pdd">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="openBind()">绑定店铺</el-button>
		</div>

		<el-alert
			v-if="listError"
			:title="listError"
			type="warning"
			show-icon
			:closable="false"
			class="list-alert"
		/>

		<div class="tablebox">
			<div class="tablediv shop-table-wrap" v-loading="listLoading">
				<el-table :data="list" size="small" class="shop-table">
					<el-table-column label="店铺名称" min-width="180" align="center" header-align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<span class="shop-name">{{ scope.row.shop_name || '-' }}</span>
						</template>
					</el-table-column>
					<el-table-column label="店铺编号" min-width="140" align="center" header-align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							{{ scope.row.shop_id || '-' }}
						</template>
					</el-table-column>
					<el-table-column label="商品" min-width="180" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="channel-cell">
								<el-tag size="mini" :type="channelMeta(scope.row, 'goods').type" effect="plain">
									{{ channelMeta(scope.row, 'goods').label }}
								</el-tag>
								<template v-if="showChannelTime(scope.row, 'goods')">
									<div class="expire-time" :class="{ 'is-expired': isChannelExpired(scope.row, 'goods') }">
										{{ formatDate(scope.row.expire_time) }}
									</div>
									<span
										v-if="isChannelExpired(scope.row, 'goods')"
										class="cell-link"
										@click="openShopOrderUrl(scope.row)"
									>去订购</span>
								</template>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="订单" min-width="180" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="channel-cell">
								<el-tag size="mini" :type="channelMeta(scope.row, 'order').type" effect="plain">
									{{ channelMeta(scope.row, 'order').label }}
								</el-tag>
								<template v-if="showChannelTime(scope.row, 'order')">
									<div class="expire-time" :class="{ 'is-expired': isChannelExpired(scope.row, 'order') }">
										{{ formatDate(scope.row.expire_time) }}
									</div>
									<span
										v-if="isChannelExpired(scope.row, 'order')"
										class="cell-link"
										@click="openShopOrderUrl(scope.row)"
									>去订购</span>
								</template>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="上架" width="100" align="center" header-align="center">
						<template slot-scope="scope">
							<el-tag size="mini" :type="channelMeta(scope.row, 'listing').type" effect="plain">
								{{ channelMeta(scope.row, 'listing').label }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="绑定时间" min-width="180" align="center" header-align="center">
						<template slot-scope="scope">
							{{ formatDate(scope.row.create_time) }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" align="center" header-align="center">
						<template slot-scope="scope">
							<div class="ops-cell">
								<span class="cell-link" @click="onShopConfig(scope.row)">店铺配置</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<el-dialog
			:title="'绑定店铺'"
			:visible.sync="bindVisible"
			width="520px"
			:close-on-click-modal="false"
			@closed="onBindClosed"
		>
			<div class="bind-guide">
				<p>商家须先在淘宝完成订购，否则绑定会失败。未订购或已过期时，请先点击下方按钮去订购。</p>
				<el-button
					type="primary"
					size="small"
					plain
					:disabled="!orderUrl"
					:loading="orderUrlLoading"
					@click="openOrderUrl"
				>去订购</el-button>
				<p v-if="!orderUrl && !orderUrlLoading" class="bind-guide-warn">暂未获取到订购地址，仍可填写主账号尝试绑定。</p>
			</div>
			<el-form ref="bindForm" :model="bindForm" :rules="bindRules" label-width="110px" size="small">
				<el-form-item label="店铺主账号" prop="seller">
					<el-input
						v-model="bindForm.seller"
						placeholder="请输入淘宝店铺主账号"
						maxlength="64"
						clearable
					/>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="bindVisible = false">取消</el-button>
				<el-button type="primary" size="small" :loading="binding" @click="onBind">确定绑定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { getApiErrorMessage } from '@/constants/retailPlatform'
	import { TB_SHOP_API, getChannelMeta, getRequestErrorMessage } from '@/constants/taobaoShop'

	export default {
		name: 'TaobaoAccount',
		data() {
			return {
				list: [],
				listLoading: false,
				listError: '',
				bindVisible: false,
				binding: false,
				orderUrl: '',
				orderUrlLoading: false,
				bindForm: {
					seller: '',
				},
				bindRules: {
					seller: [{ required: true, message: '请输入淘宝店铺主账号', trigger: 'blur' }],
				},
			}
		},
		mounted() {
			this.onlist()
		},
		methods: {
			channelMeta(row, key) {
				const channels = (row && row.channels) || {}
				return getChannelMeta(channels[key])
			},
			channelStatus(row, key) {
				const channels = (row && row.channels) || {}
				return channels[key] || 'unbound'
			},
			showChannelTime(row, key) {
				const status = this.channelStatus(row, key)
				return status === 'bound' || status === 'expired'
			},
			isChannelExpired(row, key) {
				if (this.channelStatus(row, key) === 'expired') {
					return true
				}
				if (this.channelStatus(row, key) !== 'bound') {
					return false
				}
				const timestamp = this.parseExpireTimestamp(row && row.expire_time)
				if (timestamp == null) {
					return false
				}
				return timestamp < Date.now()
			},
			onlist() {
				this.listLoading = true
				this.listError = ''
				this.$axios.get(TB_SHOP_API.shopList).then((res) => {
					if (res.data.code == 0) {
						this.list = (res.data.data && res.data.data.list) || []
					} else {
						this.list = []
						this.listError = getApiErrorMessage(res, '获取淘宝店铺失败')
					}
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.listError = getRequestErrorMessage(err, '获取淘宝店铺失败，请稍后重试')
				}).finally(() => {
					this.listLoading = false
				})
			},
			openBind() {
				this.bindForm.seller = ''
				this.bindVisible = true
				this.fetchOrderUrl()
			},
			onShopConfig(row) {
				if (!row || !row.id) {
					this.$message.warning('店铺信息不完整')
					return
				}
				sessionStorage.setItem('retailShopId', String(row.id))
				sessionStorage.setItem('storeConfigPlatform', 'taobao')
				this.$router.push({
					path: '/StoreConfig/taobao/tabsConfig',
					query: { id: row.id },
				})
			},
			fetchOrderUrl(row) {
				const fallback = row && row.order_url
				this.orderUrl = fallback || ''
				this.orderUrlLoading = true
				this.$axios.get(TB_SHOP_API.orderUrl).then((res) => {
					if (res.data.code == 0) {
						const url = res.data.data && res.data.data.order_url
						if (url) {
							this.orderUrl = url
						}
					}
				}).catch((err) => {
					console.log(err)
				}).finally(() => {
					this.orderUrlLoading = false
				})
			},
			openOrderUrl() {
				this.openUrl(this.orderUrl)
			},
			openShopOrderUrl(row) {
				const url = row && row.order_url
				if (url) {
					this.openUrl(url)
					return
				}
				this.$axios.get(TB_SHOP_API.orderUrl).then((res) => {
					const nextUrl = res.data && res.data.code == 0 && res.data.data && res.data.data.order_url
					if (nextUrl) {
						this.openUrl(nextUrl)
					} else {
						this.$message.warning('暂未获取到订购地址')
					}
				}).catch((err) => {
					console.log(err)
					this.$message.error(getRequestErrorMessage(err, '获取订购地址失败，请稍后重试'))
				})
			},
			openUrl(url) {
				if (!url) {
					this.$message.warning('暂未获取到订购地址')
					return
				}
				window.open(url, '_blank')
			},
			showBindSuccess(orderUrl, message) {
				const options = {
					title: '绑定成功',
					message: orderUrl
						? (message + '。如需再订购其他店铺，可点击下方按钮。')
						: message,
					confirmButtonText: '完成',
					type: 'success',
				}
				if (orderUrl) {
					options.showCancelButton = true
					options.cancelButtonText = '订购其他店铺'
					options.distinguishCancelAndClose = true
				}
				this.$confirm(options.message, options.title, options).then(() => {}).catch((action) => {
					if (action === 'cancel' && orderUrl) {
						this.openUrl(orderUrl)
					}
				})
			},
			onBind() {
				this.$refs.bindForm.validate((valid) => {
					if (!valid) {
						return
					}
					const seller = String(this.bindForm.seller || '').trim()
					if (!seller) {
						this.$message.warning('请输入淘宝店铺主账号')
						return
					}
					this.binding = true
					this.$axios.post(TB_SHOP_API.bind, { seller }).then((res) => {
						if (res.data.code == 0) {
							const data = (res.data && res.data.data) || {}
							this.bindVisible = false
							this.onlist()
							this.showBindSuccess(data.order_url, (res.data && (res.data.msg || res.data.message)) || '绑定成功')
						} else {
							this.$message.error(getApiErrorMessage(res, '绑定失败'))
						}
					}).catch((err) => {
						console.log(err)
						this.$message.error(getRequestErrorMessage(err, '绑定失败，请稍后重试'))
					}).finally(() => {
						this.binding = false
					})
				})
			},
			onBindClosed() {
				this.bindForm.seller = ''
				this.orderUrl = ''
				if (this.$refs.bindForm) {
					this.$refs.bindForm.resetFields()
				}
			},
			parseExpireTimestamp(expireTime) {
				if (expireTime == null || expireTime === '') {
					return null
				}
				if (typeof expireTime === 'number' || /^\d+$/.test(String(expireTime))) {
					let timestamp = Number(expireTime)
					if (String(timestamp).length === 10) {
						timestamp = timestamp * 1000
					}
					return timestamp
				}
				const parsed = this.$moment(expireTime)
				return parsed.isValid() ? parsed.valueOf() : null
			},
			formatDate(expireTime) {
				const timestamp = this.parseExpireTimestamp(expireTime)
				if (timestamp == null) {
					return '-'
				}
				return this.$moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
			},
		},
	}
</script>

<style scoped lang="less">
	.pdd {
		height: 100%;
		padding: 10px 10px 0 0;
		background-color: #fff;
		overflow: auto;
		box-sizing: border-box;
	}

	.tablebox {
		padding: 0 4px;
	}

	.list-alert {
		margin: 0 4px 12px;
	}

	.shop-table-wrap {
		background: #fff;
		border: 1px solid #ebeef5;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
	}

	.shop-table {
		font-size: 13px;
		color: #303133;
		background: transparent;

		&::before {
			height: 0;
		}

		/deep/ &::after {
			height: 1px;
			background-color: #ebeef5;
		}

		/deep/ thead {
			font-weight: normal;
		}

		/deep/ th.el-table__cell {
			background: #fafbfc;
			font-size: 13px;
			font-weight: normal;
			color: #606266;
			padding: 12px 0;
			border-right: none;
			border-bottom: 1px solid #ebeef5;

			.cell {
				font-size: 13px;
				font-weight: normal;
				line-height: 1.5;
			}
		}

		/deep/ td.el-table__cell {
			font-size: 13px;
			padding: 12px 0;
			border-right: none;
			border-bottom: 1px solid #ebeef5;

			.cell {
				font-size: 13px;
				line-height: 1.5;
			}
		}

		/deep/ tr:hover > td.el-table__cell {
			background: #fafbfc !important;
		}

		/deep/ .el-table__empty-text {
			font-size: 13px;
			color: #909399;
		}

		/deep/ .el-table__body-wrapper,
		/deep/ .el-table__header-wrapper {
			width: 100% !important;
		}
	}

	.shop-name {
		color: #303133;
	}

	.channel-cell {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
		padding: 4px 0;
	}

	.expire-time {
		color: #606266;
		font-size: 13px;
		line-height: 1.4;

		&.is-expired {
			color: #f56c6c;
		}
	}

	.ops-cell {
		display: inline-flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;
	}

	.cell-link {
		font-size: 13px;
		color: #ff4714;
		cursor: pointer;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.75;
		}
	}

	.bind-guide {
		margin: 0 0 16px;
		padding: 12px 14px;
		background: #fafbfc;
		border: 1px solid #ebeef5;
		border-radius: 8px;

		p {
			margin: 0 0 10px;
			font-size: 13px;
			line-height: 1.6;
			color: #606266;
		}

		.bind-guide-warn {
			margin: 10px 0 0;
			color: #e6a23c;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/taobao/account.vue